import React from "react";
import PropTypes from "prop-types";

import RadioInput from "core/RadioInput";
import { contentTypes } from "core/props";

import {
    RadioButtonLabel,
    DescriptionContainer,
    DescriptionHeading,
    DescriptionText,
    PriceContainer,
    PriceSubText,
    PriceWrapper
} from "./styles";

const LicenseRadio = ({
    type,
    priceSubText,
    schema: {
        id,
        selected,
        onClick,
        title,
        ariaLabel,
        price,
        attributionDisclaimer,
        meta,
        link
    }
}) => {
    let details;
    if (type === "photo") {
        details = (
            <>
                {meta.mp} {meta.pixelDimensions}, {meta.printDimensions} @{" "}
                {meta.dpi}
                <br />
                {link}
                <br />
                {attributionDisclaimer}
            </>
        );
    } else if (type === "icon") {
        // TODO
    }

    return (
        <RadioButtonLabel aria-label={ariaLabel} htmlFor={id}>
            <RadioInput
                onChange={onClick}
                name="payment-option"
                id={id}
                checked={selected}
                data-testid={id}
            />
            <DescriptionContainer>
                <DescriptionHeading>{title}</DescriptionHeading>
                <DescriptionText>{details}</DescriptionText>
            </DescriptionContainer>
            <PriceWrapper priceSubText={priceSubText}>
                <PriceContainer>{price}</PriceContainer>
                {priceSubText && <PriceSubText>{priceSubText}</PriceSubText>}
            </PriceWrapper>
        </RadioButtonLabel>
    );
};

LicenseRadio.propTypes = {
    type: PropTypes.oneOf(contentTypes).isRequired,
    priceSubText: PropTypes.string,
    schema: PropTypes.shape({
        id: PropTypes.string.isRequired,
        selected: PropTypes.bool.isRequired,
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
            .isRequired,
        ariaLabel: PropTypes.string.isRequired, // this can only be a string, never anything else
        price: PropTypes.oneOfType([
            PropTypes.string.isRequired,
            PropTypes.number.isRequired
        ]),
        attributionDisclaimer: PropTypes.string,
        meta: PropTypes.object.isRequired,
        link: PropTypes.element.isRequired,
        onClick: PropTypes.func.isRequired
    }).isRequired
};

export default LicenseRadio;
